module.exports = __webpack_public_path__ + "img/financing.2d7f76ae.svg";